import * as yup from 'yup';

import { useYupValidators } from '~/utils/yupValidators';

const useBankPaymentSchema = () => {
  const yupValidators = useYupValidators();
  const bankPaymentSchema = yup.object().shape({
    dateOfBirth: yupValidators.dateOfBirth,
    bankName: yupValidators.bankName,
    bankAccount: yupValidators.bankAccount,
  });

  return { bankPaymentSchema };
};

export { useBankPaymentSchema };
